import styled from 'styled-components';
export var InnerSpacing = styled.div.withConfig({
  displayName: "partials__InnerSpacing",
  componentId: "sc-10pltbx-0"
})(["padding:0 30px;margin-top:50px;"]);